import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    templateDetails: [],
};

const templateSlice = createSlice({
    name: "template",
    initialState,
    reducers: {
        setTemplateData: (state, action) => {
            state.templateDetails = action.payload;
        },
    },
});

export const { setTemplateData } = templateSlice.actions;
export default templateSlice.reducer;
